export function triggerAnimations(): void {
    function animateAppearance(entries: IntersectionObserverEntry[], _observer: IntersectionObserver) {
        entries.forEach((entry: IntersectionObserverEntry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate');
                entry.target.classList.remove('waiting-animation');
            }
        });
    }

    const bgObserver = new IntersectionObserver(animateAppearance, {
        threshold: 0.1
    });

    const animatableBackgrounds = Array.from(document.querySelectorAll('.animatable-bg'));

    animatableBackgrounds.forEach((item: Element) => {
        bgObserver.observe(item);
    });

    const observer = new IntersectionObserver(animateAppearance, {
        threshold: 0
    });

    const animatableBlocks = document.querySelectorAll('.waiting-animation');

    animatableBlocks.forEach(item => {
        observer.observe(item);
    });
}


export const inlineSvgModule = (function () {

    function loadSvgSpriteSheet(urlEl: Element) {
        const xmlhttp = new XMLHttpRequest();

        xmlhttp.onload = function () {
            urlEl.innerHTML = xmlhttp.responseText;
        }

        xmlhttp.open('GET', urlEl.innerHTML, true);
        xmlhttp.send();
    }

    return {
        loadAllSprites: function () {
            const inlineSvgContainer = document.getElementById('inlineSvgContainer');
            if (!inlineSvgContainer) return;

            const urls = inlineSvgContainer.querySelectorAll('.inlineSvgUrl');
            for (let i = 0; i < urls.length; i++) {
                loadSvgSpriteSheet(urls[i]);
            }
        }
    };
})();
